import OurProjects from "components/OurProjects";
import PageHeader from "components/PageHeader";
import { setBreadcrumbTitle } from "features/breadcrumb/breadcrumbSlice";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";

interface GalleryProps {}

const Gallery: React.FC<GalleryProps> = ({}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setBreadcrumbTitle("Галерия"));

    return () => {
      dispatch(setBreadcrumbTitle(""));
    };
  }, []);

  return (
    <GalleryContainer>
      <PageHeader title="Галерия" subtitle="разгледайте нашите проекти" />
      <OurProjects />
    </GalleryContainer>
  );
};

const GalleryContainer = styled.div``;

export default Gallery;
